import orderBy from 'lodash/orderBy';
import { useMemo } from 'react';

import {
    HistPriceVolDataItem,
    HistPriceVolDataState,
} from 'widgets/historicalPercentageChange/store/data/HistoricalPercentageChangeDataState.ts';
import { HistoricalPercentageChangeDataItem } from 'widgets/historicalPercentageChange/data/historicalPercentageChangeDataItem.ts';
import { DateTime } from 'luxon';
import { safeCalculatePercent } from 'utils/percent.ts';

const initItems: HistoricalPercentageChangeDataItem[] = [];
export function useHistoricalPercentageChangeData(
    streamData: HistPriceVolDataState
) {
    return useMemo(
        () =>
            orderBy(
                mapToHistoricalPercentageChangeDataItems(streamData),
                ['date'],
                ['asc']
            ),
        [streamData]
    );
}

export function mapToHistoricalPercentageChangeDataItems(
    streamData: HistPriceVolDataState | undefined
): HistoricalPercentageChangeDataItem[] {
    if (!streamData?.data || streamData.data.length === 0) {
        return initItems;
    }

    const ret: HistoricalPercentageChangeDataItem[] = [];
    let prevPrice: number | undefined;

    for (const streamItem of orderBy(streamData.data, ['index'], ['asc'])) {
        const nextItem = mapToDataItem(streamItem);
        if (nextItem.price) {
            if (prevPrice) {
                nextItem.percentChange = safeCalculatePercent(
                    nextItem.price - prevPrice,
                    prevPrice
                );
            }
            prevPrice = nextItem.price;
        }
        ret.push(nextItem);
    }

    return ret;
}

function mapToDataItem(
    item: HistPriceVolDataItem
): HistoricalPercentageChangeDataItem {
    return {
        price: item.price,
        volume: item.volume,
        date: mapDate(item),
        percentChange: undefined,
    };
}

function mapDate(item: HistPriceVolDataItem): number {
    return DateTime.fromFormat(item.date, 'yyyy-MMM-d').toMillis();
}
